import { useMemo } from 'react';
import { useApiFiltersContext } from 'contexts/ApiFiltersContext/ApiFiltersContext';
import { Suggestions, isFilterSuggestion } from '../types';

const usePredictiveInput = ({
    inputValue,
    selectedSuggestionIndex,
    suggestions,
}: {
    inputValue: string;
    selectedSuggestionIndex: number;
    suggestions: Suggestions[];
}) => {
    const { getFilterLabel } = useApiFiltersContext();

    const [predictiveModifiers, predictiveInput] = useMemo(() => {
        let predictiveInput = '';

        const fallbackSuggestionIndex = inputValue ? 0 : -1;
        const hasSelectedSuggestionIndex = selectedSuggestionIndex !== -1;
        const suggestionsIndex = hasSelectedSuggestionIndex
            ? selectedSuggestionIndex
            : fallbackSuggestionIndex;
        const showInlineSuggestion = suggestionsIndex !== -1;

        if (
            !suggestions ||
            !showInlineSuggestion ||
            suggestions?.length - 1 < suggestionsIndex
        ) {
            return [undefined, predictiveInput];
        }

        const filterSuggestions = suggestions.filter(isFilterSuggestion);

        const [modifiers] = filterSuggestions[suggestionsIndex] ?? [];

        if (modifiers) {
            const [params, slug] = modifiers;

            predictiveInput = slug ? getFilterLabel(slug, params) : '';
        }

        return [modifiers, predictiveInput];
    }, [inputValue, selectedSuggestionIndex, suggestions, getFilterLabel]);

    return { predictiveModifiers, predictiveInput };
};

export default usePredictiveInput;
